import {useCallback} from '@wordpress/element';

export const useApplePayButton = (
    {
        onClick,
        onClose,
        onError,
        createSession
    }) => {

    /**
     * Handle button click - initiates Apple Pay payment flow
     */
    const onButtonClick = useCallback(async (e) => {
        try {
            e.preventDefault();

            if (onClick) {
                onClick();
            }

            const session = await createSession();

            if (session) {
                // Begin the Apple Pay session
                session.begin();
            }
        } catch (error) {
            if (error?.code === 'CANCELED') {
                if (onClose) {
                    onClose();
                }
                // User canceled, don't show error
                return;
            }
            if (onError) {
                onError(error?.message || error);
            }
        }
    }, [
        onClick,
        onClose,
        onError,
        createSession
    ]);

    return {
        onButtonClick
    };
};

export default useApplePayButton;